import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { Button } from 'telstra-ui/components/button/Button';
import { GenericAlert } from 'telstra-ui/components/generic-alert/GenericAlert';
import SummaryDetails from '../../../ssm-homepage/ssm-components/summary-details/summary-details';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';
import PlanTableView from '../plan_table_view/plan_table_view';
import Benefit from '../benefit/benefit';
import EstimatedTotalBox from '../estimated-total-box/estimated-total-box';

import {
  OLD_PLAN_TYPE,
  NEW_PLAN_TYPE,
  PLAN_TABLE_ACCOUNT_SELECTED_CLASS,
  PLAN_TABLE_ACCOUNT_NOT_SELECT_CLASS,
  NGM_YES_TEXT,
} from '../../../../app-constants';

class RecommendedPlans extends Component {
  static defaultProps = {
    estimatedBox: true,
    recommendationBanner: false,
    numberSearchDropdown: false,
  }
  state = {
    oldPlanNumbersHideShowData: [],
    newPlanNumbersHideShowData: [],
    selectedPlanNumber: '',
    selectedPlanType: '',
    currentPlanTableExpandCollapse: false,
    suggestPlanExpandCollapse: false,
    scrollBothSide: false,
    searchSelectedPlanNumber: '',
    optionsForSearchInput: [],
    displayOptions: [],
  }

  componentDidMount() {
    this.setPlanHideShowFlag(this.props.suggestedPlanDetails.length, NEW_PLAN_TYPE, false);
    this.setPlanHideShowFlag(this.props.planDetails.length, OLD_PLAN_TYPE, false);
    if (this.props.numberSearchDropdown) {
      this.createOptionsForSearchInput(this.props.planDetails);
    }
  }

  componentDidUpdate() {
    this.scrollNumberPillfun();
  }

  setPlanHideShowFlag = (planListLength, planType, flag) => {
    const setDataObj = [];
    for (let i = 0; i < planListLength; i += 1) {
      setDataObj[i] = flag;
    }
    if (planType === OLD_PLAN_TYPE) {
      this.setState({ oldPlanNumbersHideShowData: setDataObj,
        currentPlanTableExpandCollapse: flag });
    } else if (planType === NEW_PLAN_TYPE) {
      this.setState({ newPlanNumbersHideShowData: setDataObj,
        suggestPlanExpandCollapse: flag });
    }

    /** add functionality for both side number pill scrolling  */
    this.setState({ scrollBothSide: flag }, () => { this.scrollNumberPillsBothSideFun(); });
  };


  handlePlansShowHide = (key, type, flag, bothSideScroll) => {
    const oldPlanData = this.state.oldPlanNumbersHideShowData;
    const newPlanData = this.state.newPlanNumbersHideShowData;
    if (type === OLD_PLAN_TYPE) {
      oldPlanData[key] = flag;
    } else if (type === NEW_PLAN_TYPE) {
      newPlanData[key] = flag;
    }
    this.setState({ oldPlanNumbersHideShowData: oldPlanData, newPlanNumbersHideShowData: newPlanData, scrollBothSide: bothSideScroll },
      () => { this.checkAllPlanStatus(type); this.scrollNumberPillsBothSideFun(); });
  };

  scrollNumberPillfun = () => {
    if (this.state.selectedPlanType && this.state.selectedPlanNumber) {
      let plantype;
      if (this.state.selectedPlanType === OLD_PLAN_TYPE) {
        plantype = NEW_PLAN_TYPE;
      } else if (this.state.selectedPlanType === NEW_PLAN_TYPE) {
        plantype = OLD_PLAN_TYPE;
      }
      const element = document.getElementById(`${this.state.selectedPlanNumber.replace(/\s+/g, '')}-${plantype}`);
      const scrollElementDiv = document.querySelector(`.${plantype} .selected-number.table-row .badge-account-section`);
      if (element && scrollElementDiv) {
        scrollElementDiv.scrollTop = element.offsetTop;
      }
    }
  }

  /** function for both side scrolling accoding to number pills */
  scrollNumberPillsBothSideFun = () => {
    if (this.state.scrollBothSide) {
      const element = document.getElementById(`${this.state.selectedPlanNumber.replace(/\s+/g, '')}-${OLD_PLAN_TYPE}`);
      const scrollElementDiv = document.querySelector(`.${OLD_PLAN_TYPE} .selected-number.table-row .badge-account-section`);
      if (element && scrollElementDiv) {
        scrollElementDiv.scrollTop = element.offsetTop;
      }

      const newElement = document.getElementById(`${this.state.selectedPlanNumber.replace(/\s+/g, '')}-${NEW_PLAN_TYPE}`);
      const newScrollElementDiv = document.querySelector(`.${NEW_PLAN_TYPE} .selected-number.table-row .badge-account-section`);
      if (newElement && newScrollElementDiv) {
        newScrollElementDiv.scrollTop = newElement.offsetTop;
      }
    }
  }

  checkNumberIndex = () => {
    if (this.state.selectedPlanType && this.state.selectedPlanNumber) {
      let planList;
      let planType;
      let planIndex;
      if (this.state.selectedPlanType === OLD_PLAN_TYPE) {
        planList = this.props.suggestedPlanDetails;
        planType = NEW_PLAN_TYPE;
      } else if (this.state.selectedPlanType === NEW_PLAN_TYPE) {
        planList = this.props.planDetails;
        planType = OLD_PLAN_TYPE;
      }

      planList.map((plan, index) => {
        if (plan.numbersOnPlan.filter(value => value === this.state.selectedPlanNumber)[0]) {
          planIndex = index;
        }
        return true;
      });

      if (planIndex !== undefined && planIndex !== null) {
        this.handlePlansShowHide(planIndex, planType, true, false);
      }
    }
  }

  checkAllPlanStatus = (PlanType) => {
    if (PlanType === OLD_PLAN_TYPE) {
      const oldPlanStatus = this.state.oldPlanNumbersHideShowData;
      const isAllEqual = oldPlanStatus.every(v => v === oldPlanStatus[0]);
      if (isAllEqual) {
        this.setState({ currentPlanTableExpandCollapse: oldPlanStatus[0] });
      }
    } else if (PlanType === NEW_PLAN_TYPE) {
      const newPlanStatus = this.state.newPlanNumbersHideShowData;
      const isAllEqual = newPlanStatus.every(v => v === newPlanStatus[0]);
      if (isAllEqual) {
        this.setState({ suggestPlanExpandCollapse: newPlanStatus[0] });
      }
    }
  }

  handleNumberSelection = (number, flag, tableType) => {
    let selectedPlanNumber;
    if (PLAN_TABLE_ACCOUNT_SELECTED_CLASS === flag) {
      selectedPlanNumber = '';
    } else if (PLAN_TABLE_ACCOUNT_NOT_SELECT_CLASS === flag) {
      selectedPlanNumber = number;
    }
    this.setState({ selectedPlanNumber, selectedPlanType: tableType }, () => this.checkNumberIndex());
  };

  handleExpandCollapseAllPlans = (planlength, TableExpandCollapse, tableType) => {
    this.setPlanHideShowFlag(planlength, tableType, !TableExpandCollapse);
  }

  createOptionsForSearchInput = (planDetails) => {
    const Options = [];
    planDetails.map((planList) => {
      planList.numbersOnPlan.map((number) => {
        const Data = { displayText: number.replace(/ /g, ''), itemId: number.replace(/ /g, '') };
        return Options.push(Data);
      });
      return false;
    });
    this.setState({ optionsForSearchInput: Options, displayOptions: Options, searchSelectedPlanNumber: '' });
  }

  searchNumber = (event) => {
    const searchText = event.target.value;
    const options = this.state.optionsForSearchInput.filter((option) => {
      const optionText = option.displayText;
      const textWithoutSpaces = optionText.replace(/ /g, '');
      const match = textWithoutSpaces.match(searchText);
      if (match != null && match.index !== undefined) {
        return true;
      }
      return false;
    });
    this.setState({ displayOptions: options });
  }

  selectSearchOption = (event) => {
    const selectedNumber = event.target.getAttribute('data-item');
    this.setState({
      searchSelectedPlanNumber: selectedNumber,
      selectedPlanNumber: selectedNumber,
      selectedPlanType: NEW_PLAN_TYPE,
      scrollBothSide: true,
    }, () => {
      this.checkNumberIndex();
      this.setState({ selectedPlanType: OLD_PLAN_TYPE }, () => { this.checkNumberIndex(); this.scrollNumberPillsBothSideFun(); });
      this.props.setSearchUsedValue({ searchUsed: NGM_YES_TEXT });
    });
  }

  render() {
    const {
      recommededPlans: {
        recommededPlanHeading,
        estimatedPriceText,
        strategicSolutions,
        currentFleet,
        siosText,
        totalText,
        expandAllText,
        collapseAllText,
        gbText,
        exportcsvText,
      },
      planDetails,
      recommededPlanDescription,
      suggestedPlanDetails,
      estimatedTotalCurrentMonthlyCost,
      estimatedTotalNewMonthlyCost,
      benefitValues,
      searchDropdownText,
      customHeadingClass,
      recommendationBanner,
      recommendationTier,
      handleDownloadCSVFile,
      excelFileDownloadInProgress,
      estimatedBox,
      numberSearchDropdown,
    } = this.props;

    const oldPlanTableKeys = {
      tableHeading: currentFleet,
      siosText,
      planDetails,
      totalText,
      expandAllText,
      collapseAllText,
    };

    const newPlanTableKeys = {
      tableHeading: strategicSolutions,
      siosText,
      planDetails: suggestedPlanDetails,
      totalText,
      expandAllText,
      collapseAllText,
    };

    let moreDataBenefit = {};
    let amountPerMonthBenefit = {};
    let additionalDataBenefit = {};
    let perMonthBenefit = 0;
    if (benefitValues !== null && benefitValues !== undefined) {
      moreDataBenefit = { ...this.props.moreDataBenefit, benefitValues: benefitValues.moreDataBenefit };
      perMonthBenefit = Math.floor(parseFloat(benefitValues.amountPerMonthBenefit));
      amountPerMonthBenefit = {
        ...this.props.amountPerMonthBenefit,
        benefitValues: `<sup>$</sup>${perMonthBenefit}`,
      };
      additionalDataBenefit = {
        ...this.props.additionalDataBenefit,
        benefitValues: `${benefitValues.additionalDataBenefit}<sup>${gbText}</sup>`,
      };
    }

    return (
      <div className="recommended-plans-section padding-top-bottom-24">
        <SummaryDetails
          summaryTitle={recommededPlanHeading}
          summaryText={stripStartingAndEndingPTags(recommededPlanDescription)}
          customHeadingClass={customHeadingClass}
        />
        {recommendationBanner &&
          <div className="row tier-banner padding-top-bottom-24 pt-0">
            <div className="col-12 pl-sm-0">
              <GenericAlert
                name="ngm-recommended-plan-banner-primary"
                showBackground={false}
                header={this.props.recommededPlans[recommendationTier].title}
                description={renderHTML(stripStartingAndEndingPTags(this.props.recommededPlans[recommendationTier].summary))}
              />
            </div>
          </div>
        }
        {benefitValues &&
          <div className="benefit-widget-section padding-top-bottom-24 row text-center" id="benefit-widget-section">
            <Benefit
              benefit={moreDataBenefit}
              applyOffset={(perMonthBenefit > 0) === false}
            />
            {(perMonthBenefit > 0) &&
              <Benefit
                benefit={amountPerMonthBenefit}
              />
            }
            <Benefit
              benefit={additionalDataBenefit}
            />
          </div>
        }
        {estimatedBox &&
          <div className="estimated-box-section padding-top-bottom-24">
            <div className="row">
              <div className="col-md-6 old-plan-cost">
                <EstimatedTotalBox
                  estimatedSection={estimatedTotalCurrentMonthlyCost}
                />
              </div>
              <div className="col-md-6 new-plan-cost">
                <EstimatedTotalBox
                  estimatedSection={estimatedTotalNewMonthlyCost}
                />
              </div>
              <div className="col-md-12 pl-sm-0 estimatedPriceText">
                {renderHTML(estimatedPriceText)}
              </div>
            </div>
          </div>
        }
        {numberSearchDropdown &&
          <div className="row number-search-section">
            <div className="col-lg-4 col-sm-12 search-drop-down">
              <Dropdown
                dropdownId="number-search-dropdown"
                label={searchDropdownText}
                value={this.state.searchSelectedPlanNumber}
                searchOnChange={this.searchNumber}
                searchBox
                highlightSelected
                options={this.state.displayOptions}
                onOptionClick={this.selectSearchOption}
              />
            </div>
            <div className="col-lg-8 col-sm-12 text-right file-export">
              <Button
                variant="primary"
                onClick={handleDownloadCSVFile}
                icon={`${excelFileDownloadInProgress ? 'icon-system-loading' : 'icon-system-download'}`}
                size="medium"
                iconPosition="right"
                className="test-class"
              >
                {exportcsvText}
              </Button>
            </div>
          </div>
        }
        <div className="row plan-table-section padding-top-bottom-24 row" id="plan-table-section">
          <div className={`col-6 ${OLD_PLAN_TYPE}`}>
            <PlanTableView
              planTableData={oldPlanTableKeys}
              showHideNumbersSection={this.state.oldPlanNumbersHideShowData}
              handlePlansShowHide={this.handlePlansShowHide}
              tableType={OLD_PLAN_TYPE}
              expandedFeature
              handleNumberSelection={this.handleNumberSelection}
              selectedPlanNumber={this.state.selectedPlanNumber}
              handleExpandCollapseAllPlans={this.handleExpandCollapseAllPlans}
              tableExpandCollapse={this.state.currentPlanTableExpandCollapse}
            />
          </div>
          <div className={`col-6 ${NEW_PLAN_TYPE}`}>
            <PlanTableView
              planTableData={newPlanTableKeys}
              showHideNumbersSection={this.state.newPlanNumbersHideShowData}
              handlePlansShowHide={this.handlePlansShowHide}
              tableType={NEW_PLAN_TYPE}
              expandedFeature
              handleNumberSelection={this.handleNumberSelection}
              selectedPlanNumber={this.state.selectedPlanNumber}
              handleExpandCollapseAllPlans={this.handleExpandCollapseAllPlans}
              tableExpandCollapse={this.state.suggestPlanExpandCollapse}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default RecommendedPlans;
